import { cx } from '@linaria/core';
import { useDynamicUnderlineStyling, UnderlineDirections } from './hooks/useDynamicUnderlineStyling.js';
import { underlineCls } from './styles.js';
export { selectors as tabUnderlineSelectors, tabUnderlineTokens } from './styles.js';
import { jsx } from 'react/jsx-runtime';

const TabUnderline = props => {
  const visible = useDynamicUnderlineStyling(props);
  const ComponentType = props.as ?? "span";
  return /*#__PURE__*/jsx(ComponentType, {
    className: cx(underlineCls, props.className, visible && "visible", (props.direction === undefined || props.direction === UnderlineDirections.HORIZONTAL) && "horizontal", props.direction === UnderlineDirections.VERTICAL && "vertical"),
    role: "presentation"
  });
};

export { TabUnderline, UnderlineDirections };
//# sourceMappingURL=index.js.map
